module.exports = "/../../dist/frontend/images/hero_banner_mobile.webp?a079ce0cc369b60758248d709417426a";